import React, { useState, useEffect } from 'react'
import Title from '../../Title'
import Select from 'react-select'
import NumberHorizontalLayout from '../../layouts/NumberHorizontalLayout'
import PieChartLayout from '../../layouts/PieChartLayout'
import classnames from 'classnames'


export default function TransitionSurvey(props) {
  const metrics = [
    {
      title: 'Patients planning on attending an IOP or next level of care',
      format: 'number_horizontal',
      endpoint: 'patients_planning_iop',
      visible: true,
    },
    {
      title: 'Patients satisfied with care at Tres Vista ',
      format: 'number_horizontal',
      endpoint: 'patients_satisfied_with_care',
      visible: true,
    },
    {
      title: 'Patients treated with dignity and respect',
      format: 'number_horizontal',
      endpoint: 'patients_treated_with_dignity',
      visible: true,
    },
    {
      title: 'Patients with quality of life improvement after treatment',
      format: 'number_horizontal',
      endpoint: 'patients_with_quality_of_life_improv',
      visible: true,
    },
    {
      title: 'Patients with family and personal relationship improvement after treatment',
      format: 'number_horizontal',
      endpoint: 'patients_with_personal_relationship_improv',
      visible: true,
    },
    {
      title: 'Patients who felt safe with their counselor and therapist',
      format: 'number_horizontal',
      endpoint: 'patients_who_felt_safe_with_therapist',
      visible: true,
    },
    {
      title: 'Patients who felt safe with their treatment plan and goals',
      format: 'number_horizontal',
      endpoint: 'patients_who_felt_safe_with_plans',
      visible: true,
    },
    {
      title: 'Patients who felt safe in group',
      format: 'number_horizontal',
      endpoint: 'patients_who_felt_safe_in_group',
      visible: true,
    },
    {
      title: 'Patients who felt safe at the home',
      format: 'number_horizontal',
      endpoint: 'patients_who_felt_safe_at_the_home',
      visible: true,
    },
    {
      title: 'Patients who felt unsafe in treatment',
      format: 'number_horizontal',
      endpoint: 'patients_who_felt_unsafe_in_treatment',
      visible: true,
    },
    
  ]

  const effective_parts_metric = {
      title: 'Most effective part of treatment center',
      format: 'pie_chart',
      endpoint: 'most_effective_part_of_treatment_center',
      visible: true,
    }

  return(
    <div>
      <div className="ml-4">
        <div className="col-12 mt-4 bg-white p-0 shadow">
          <div className="bg-info p-3">
            <div className="col-12 text-align-left title">Transition Survey</div>
          </div>
          <div className="col-12 d-flex flex-wrap p-4 ml-2">
            {
            metrics.filter( metric => metric.visible == true ).map( (metric, index) => {
              return <div className={classnames("pt-3", "col-12", "col-lg-6", "pl-0", { "pl-lg-3": true })} >
                <div className='bg-reg shadow mt-2'>
                  <NumberHorizontalLayout {...props} metric={metric} index={index} /> 
                </div>
              </div>
            })
            }

          <div className={classnames("pt-3", "col-12", "col-lg-6", "pl-0", { "pl-lg-6": true })} key={metrics.length}>
            <div className='bg-reg'>
              <PieChartLayout {...props} metric={effective_parts_metric} index={metrics.length} /> 
            </div>
          </div>

          </div>
        </div>
      </div>

    </div>
  )
}
